import * as authorization from 'auth-header';
import Fetcher from '@gandi/fetcher';
import createFetcherMiddleware from 'gandi.redux-fetcher';
export function getCustomAuthenticate(logger, authenticateHeader) {
  if (typeof window !== 'undefined' && typeof authenticateHeader === 'string') {
    let wwwAuthenticate;
    try {
      wwwAuthenticate = authorization.parse(authenticateHeader);
      if (wwwAuthenticate.scheme === 'Bearer' && wwwAuthenticate.params.realm && wwwAuthenticate.params.type) {
        logger.info('Authentication challenge:', wwwAuthenticate.params.realm);
        return wwwAuthenticate;
      }
    } catch (err) {
      logger.warn({
        err
      }, `Invalid 'WWW-Authenticate' challenge: ${authenticateHeader}`);
    }
    logger.warn({
      wwwAuthenticate
    }, `Unknown 'WWW-Authenticate' challenge: ${authenticateHeader}`);
  }
  return undefined;
}
export function dispatchAuthenticate(wwwAuthenticate, data) {
  const custom401Event = new CustomEvent('authenticate', {
    bubbles: true,
    detail: {
      ...wwwAuthenticate,
      data
    }
  });
  document.dispatchEvent(custom401Event);
}
class InstrumentedFetcher extends Fetcher {
  constructor(baseUrl, options = {}, instrumentation = null) {
    super(baseUrl, options);
    if (instrumentation) {
      this._instrumentation = instrumentation;
    }
  }
  fetch(url, fetchOptions = {}) {
    if (!this._instrumentation) {
      return super.fetch(url, fetchOptions);
    }
    const tracer = this._instrumentation.subrequest();
    const req = tracer.trace(url, fetchOptions);
    return super.fetch(url, req.opts).then(req.success, req.error);
  }
}
const getOptions = target => args => {
  const {
    appUrl,
    locale,
    req,
    ...opt
  } = args;
  let options = {
    ...opt
  };
  if (target === 'server' && req && typeof appUrl !== 'undefined') {
    const headers = {
      origin: appUrl,
      'X-Real-IP': req.ip,
      'X-Forwarded-For': req.ip,
      'X-Forwarded-Proto': req.protocol,
      'X-Forwarded-Port': req.protocol === 'https' ? '443' : '80',
      'Accept-Language': locale
    };
    if (req.get('X-Country-Code')) {
      headers['X-Country-Code'] = req.get('X-Country-Code');
    }
    if (req.cookies.get('session')) {
      headers.Cookie = `session=${req.cookies.get('session')}`;
    }
    options = {
      ...options,
      headers
    };
  }
  if (target === 'client') {
    const headers = {
      'Accept-Language': locale
    };
    options = {
      ...options,
      headers
    };
  }
  return options;
};
export const initFetcherMiddleware = (logger, __, target, apiEndpoint, locale, appUrl) => fetcherOptionsArgs => {
  let fetcher = new Fetcher(apiEndpoint);
  if (target === 'server' && fetcherOptionsArgs.req && fetcherOptionsArgs.req.tracer) {
    const {
      req
    } = fetcherOptionsArgs;
    const instrumentation = req.tracer;
    fetcher = new InstrumentedFetcher(apiEndpoint, {}, instrumentation);
  }
  fetcher.setOptions(getOptions(target)({
    ...fetcherOptionsArgs,
    locale,
    appUrl
  }));
  const defaultHandlers = () => ({
    on401: async res => {
      const authenticateChallenge = getCustomAuthenticate(logger, res.headers.get('www-authenticate'));
      if (authenticateChallenge) {
        let data = res.data;
        if (typeof res.data === 'string') {
          data = JSON.parse(res.data);
        }
        dispatchAuthenticate(authenticateChallenge, data);
        return;
      }
      logger.info({
        res
      }, `401 Unauthorized : ${typeof res.data === 'object' && typeof res.data.message === 'string' ? res.data.message : 'N/A'}`);
      if (typeof window !== 'undefined') {
        const lang = locale;
        window.location = `${apiEndpoint}/login?locale=${lang}&redirect=${window.location}`;
      } else {
        logger.error('Uncaught unauthorized error');
      }
    }
  });
  return createFetcherMiddleware(fetcher)(defaultHandlers);
};